<template>
    <div class="LearnSection">
        <h2>Learn how to use DumpTek</h2>
        <Row>
            <Column
                v-for="tutorial in tutorials"
                :key="tutorial.youtubeId"
                :lg="4"
            >
                <Card>
                    <Video :videoId="tutorial.youtubeId" playInNewTab />
                    <h3>{{ tutorial.title }}</h3>
                    <p>{{ tutorial.description }}</p>
                </Card>
            </Column>
        </Row>
    </div>
</template>

<script>
import Card from '@/components/Card';
import Video from '@/components/Video';

export default {
    name: 'LearnSection',

    components: {
        Card,
        Video,
    },

    data: () => ({
        tutorials: [
            {
                title: 'Getting Started',
                description: 'We will go over how to add drivers, jobs, and trucks, downloading the app to submit your first ticket, and viewing reports.',
                youtubeId: '-QyedHKM1d4',
            },
            {
                title: 'QuickBooks Invoicing',
                description: 'Learn how to create invoices with QuickBooks Online using the data from DumpTek.',
                youtubeId: 'Xbl88_AQP4M',
            },
        ],
    }),
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.LearnSection {
    h2 {
        margin-bottom: $grid-gutter-width;
    }

    h3 {
        margin-bottom: 10px;
    }

    .actions {
        margin-top: $grid-gutter-width * 2;
    }

    .Card {
        padding: 30px;
        min-height: 370px;
    }

    .Video {
        margin-bottom: 20px;
    }
}
</style>
